import api from "@/api";

export default {
  // Lấy danh sách tài liệu của công trình
  getByCongTrinh(congTrinhId) {
    return api.get(`/api/cong-trinh/${congTrinhId}/tai-lieu`);
  },

  // Thêm mới tài liệu
  create(congTrinhId, data) {
    return api.post(`/api/cong-trinh/${congTrinhId}/tai-lieu`, data);
  },

  // Cập nhật tài liệu
  update(id, data) {
    return api.put(`/api/cong-trinh/tai-lieu/${id}`, data);
  },

  // Xóa tài liệu
  delete(id) {
    return api.delete(`/api/cong-trinh/tai-lieu/${id}`);
  }
};